module.exports = __webpack_public_path__ + "域名 .png?44cbf5a92bad8c018b60fad3de9cf565";


//////////////////
// WEBPACK FOOTER
// ./static/assets/域名 .png
// module id = 489
// module chunks = 0